module.exports = __webpack_public_path__ + "static/media/button3.5f893a06.png";